import { $http } from './http'

const BASE_PATH = '/pos/method-payment-configuration'

class PosService {
  getPOSMethodPaymentConfiguration = async (posId: number) => {
    const response = await $http.get<POSMethodPaymentConfiguration>(
      `${BASE_PATH}/${posId}`,
    )
    return response.data
  }
  savePOSMethodPaymentConfiguration = async (request: POSMethodPaymentConfiguration) => {
    const response = await $http.post(`${BASE_PATH}`, request)
    return response.data
  }
}

export default new PosService()
